var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "checkbox-background",
    d: "M1.173961 14C.558871 13.99559.049604 13.52264 0 12.91078V1.173006C.013228.530278.531314.012126 1.173961 0h11.735203c.623908.020947 1.11113.543507 1.090185 1.167493V12.91078c-.011023.597528-.492733 1.079298-1.090185 1.08922H1.17396z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "checkbox-border",
    d: "M13.333179.000857H1.667464C.747107.003.003536.747643.000321 1.668v11.664643c.002143.920357.746786 1.665 1.667143 1.667143H13.33318c.919285-.002143 1.665-.746786 1.667142-1.667143V1.668C14.99818.747643 14.252464.001929 13.33318-.000214v.001071zm0 1.082021c.313928-.006307.575357.242265.582857.557265V13.332643c.0075.315-.243215.575357-.557143.582857H1.667464c-.315.0075-.576428-.241071-.582857-.556071-.001071-.009643-.001071-.018215 0-.026786V1.668c-.0075-.315.241072-.576429.556072-.582857.009642-.001072.018214-.001072.026785 0H13.33318v-.002265z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "checkbox-tick",
    d: "M5.9281 11L2 7.634005l1.1-.941866 2.8281 2.423035L11.9 4l1.1.941866z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "checkbox-partial",
    d: "M3.667 7.933h10.667v1.813H3.667z",
    transform: "translate(-1.5 -1)",
    height: 2,
    width: 11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/Checkbox.d010e102cd02b5731e3464167542ab9d.svg";
export { ForwardRef as ReactComponent };